
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { VapidKeyGenerator } from "@/components/notifications/VapidKeyGenerator";

export const VapidKeyManagement = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>VAPID Key Management</CardTitle>
        <CardDescription>
          Generate and manage VAPID keys for web push notifications
        </CardDescription>
      </CardHeader>
      <CardContent>
        <VapidKeyGenerator />
      </CardContent>
    </Card>
  );
};
